/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sl_In_Reason_From_Sorting_ProcessInputs */

const vi_sl_in_reason_from_sorting_process = /** @type {(inputs: Sl_In_Reason_From_Sorting_ProcessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Từ phiếu cân chè khô`)
};

/**

* @param {Sl_In_Reason_From_Sorting_ProcessInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sl_in_reason_from_sorting_process = /** @type {((inputs?: Sl_In_Reason_From_Sorting_ProcessInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sl_In_Reason_From_Sorting_ProcessInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sl_in_reason_from_sorting_process(inputs)
});